import { Box, Stack, Tooltip } from '@mui/material';
import { Link } from 'react-router';

import { CopyButton } from './CopyButton';

type LinkWithCopyButtonProps = {
  readonly text: string;
  readonly to: string;
  readonly tooltip: string;
};

const styles = {
  link: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
  },
};

export const LinkWithCopyButton = ({ text, to, tooltip }: LinkWithCopyButtonProps) => (
  <Stack direction="row" alignItems="center" spacing={0.5}>
    <Box sx={styles.link}>
      <Tooltip title={tooltip} arrow>
        <Link to={to} target="_blank">
          {text}
        </Link>
      </Tooltip>
    </Box>
    <CopyButton text={text} />
  </Stack>
);
